import {InitPage} from "../index";


class ElcAlarm {
    constructor() {
    }

    create_elc_alarm_form(){
        var alarmType = $('#elc_alarm_alarm_type').find(':selected').attr('data-value');
        if(alarmType == 'nrp' || alarmType == 'ns'){
            $('#report_every_set_col').show();
            $('#alarm_interval_cols').show();
            $('#email_interval_col').show();
            $('#variance_cols').hide();
            $('#wo_qty_cols').hide();
          }
        else if(alarmType == 'pv'){
            $('#report_every_set_col').hide();
            $('#alarm_interval_cols').hide();
            $('#email_interval_col').hide();
            $('#variance_cols').show();
            $('#wo_qty_cols').hide();
            $('#max_emails_col').hide();
            $('#variance_cols').hide();
          }
        else if(alarmType == 'fqpv'){
            $('#report_every_set_col').hide();
            $('#alarm_interval_cols').hide();
            $('#email_interval_col').hide();
            $('#variance_cols').hide();
            $('#wo_qty_cols').hide();
            $('#max_emails_col').hide();
          }
        else if(alarmType == 'hr' || alarmType == 'pp'){
            $('#report_every_set_col').hide();
            $('#alarm_interval_cols').hide();
            $('#email_interval_col').show();
            $('#variance_cols').hide();
            $('#wo_qty_cols').hide();
          }

          if(alarmType == 'hr')
            $('#status_row').show();
          else
            $('#status_row').hide();

         if(alarmType == 'pv' || alarmType == 'fqpv'){
            $('#two-col-rule').show();
            $('#one-col-rule').hide();
            $('#elc_alarm_destination_email_min_rule').attr('required', 'required');
            $('#elc_alarm_destination_email_max_rule').attr('required', 'required');
            $('#elc_alarm_destination_email_rule').removeAttr('required');
          }
          else{
            $('#two-col-rule').hide();
            $('#one-col-rule').show();
            $('#elc_alarm_destination_email_rule').attr('required', 'required');
            $('#elc_alarm_destination_email_min_rule').removeAttr('required');
            $('#elc_alarm_destination_email_max_rule').removeAttr('required');


          }

          if(alarmType == 'fqpv')
            {
              $('#min-rule-label').text('Rule: Min (%)');
              $('#max-rule-label').text('Max (%)');
            }
    }
}

declare global {
    interface Window {
        create_elc_alarm_form: () => void;
    }
}

export function LoadPage() {
    InitPage("alarms", () => {
        const c = new ElcAlarm();
        window.create_elc_alarm_form = c.create_elc_alarm_form;
    });
}
